import { z } from "zod";
import { npdCalculationFailureDtoSchema } from "./npd-calculation-failure.schema";
export const npdCalculationErrorsDtoSchema = z.array(npdCalculationFailureDtoSchema);
